import React from "react";
import PropTypes from "prop-types";
import { MileageForm, CarConfirmation } from "valuations-journey";
import { useSelector } from "react-redux";
import { PageLayout } from "../../components";
import { getAppraisalData } from "../../store/selectors";
import OdometerAlert from "../../components/OdometerAlert";

export default function MileageOnly({
  onSubmit,
  handleWrongCar,
  handleMileageInput,
  validationError,
  isBranchAppraisal,
  loading,
  mileage,
  hasError
}) {
  const { vehicle } = useSelector(getAppraisalData);
  const { manufacturer, model, registration, motLastMileage, derivative } =
    vehicle;

  const make = `${manufacturer} ${model}`;
  const mileageAtLastMot = motLastMileage ? motLastMileage : 0;
  return (
    <>
      <PageLayout>
        <PageLayout.Header title="Record mileage" step={1} steps={2} />
        <PageLayout.Content>
          <h3 className="ch-fs--4">Enter your mileage</h3>
          <p className="ch-form__control-hint ch-mb--4 ch-fs--3 ch-color--grey-6">
            {mileageAtLastMot === 0
              ? "Enter the mileage shown on your odometer."
              : `
            Mileage cannot be lower than ${mileageAtLastMot} based on your last MOT.`}
          </p>
          <div className="ch-card">
            <div className="ch-card__content mileage-card">
              <div
                className={
                  isBranchAppraisal ? "branch-appraisal-car-confirmation" : ""
                }
              >
                <CarConfirmation
                  car={{
                    make: make,
                    variant: derivative,
                    registration: registration
                  }}
                  handleWrongCar={handleWrongCar}
                />
              </div>
            </div>
            <div className="ch-card__content ch-card__content--grey ch-shadow--md ch-shadow--darker mileage-card">
              <MileageForm
                value={mileage || ""}
                onChange={({ target: { value } }) => handleMileageInput(+value)}
                error={validationError}
                mileageAtLastMot={motLastMileage ? motLastMileage : 0}
              >
                <div />
              </MileageForm>
            </div>
          </div>
          <OdometerAlert />
          {hasError && (
            <div className="ch-alert ch-alert--danger ch-mt--2">
              We're sorry, something went wrong, please try again later!
            </div>
          )}
        </PageLayout.Content>
        <PageLayout.Footer>
          <button
            className={`ch-btn ch-btn--success ch-display--flex ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4 ${
              loading && "ch-btn--loading"
            }`}
            type="button"
            onClick={() => onSubmit(motLastMileage)}
          >
            Take odometer photo
          </button>
        </PageLayout.Footer>
      </PageLayout>
    </>
  );
}

MileageOnly.propTypes = {
  handleWrongCar: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleMileageInput: PropTypes.func.isRequired,
  mileage: PropTypes.number
};
